import React, { Component } from 'react';

import { IsListEmpty } from '../../../utilities/CommonMethods';
import classes from './Tabs.module.css';

class Tabs extends Component {

    onTabClick = (pos) => {
        if(!IsListEmpty(this.props.tabList)) {
            if(pos >= (this.props.tabList.length / 2)) {        
                this.tabList.scrollLeft += 500;
            } else {
                this.tabList.scrollLeft -= 500;
            }
        }
        this.props.onTabClick(pos);
    }

    render() {
        let styleClasses = [classes.Tabs];

        if(this.props.styleclass !== undefined) {
            const styles = this.props.styleclass.split(' ');
            for(let style in styles) {
                styleClasses.push(classes[styles[style].trim()]);
            }
        }
    
        const tabs = this.props.tabList.map((item, pos) => {
            return (
                <h3 
                    key={pos}
                    className={[classes.TabItem, (this.props.currentTab === pos ? classes.Active : null)].join(' ')}
                    onClick={() => this.onTabClick(pos)}
                    >
                    {item.label}
                </h3>
            )
        })
    
        return(
            <div className={styleClasses.join(' ')} ref={tabList => (this.tabList = tabList)}>
                {tabs}
            </div>
        );
    }
}

export default Tabs;